// Via https://stackoverflow.com/a/22480938

export function isElementVisible(el) {
  const { top, bottom } = el.getBoundingClientRect();

  return top >= 0 && bottom <= window.innerHeight;
}
